
import styled from 'styled-components'
import { mediaQueries } from '../shared/config'

const Container = styled.div`
    height: auto;
    max-width: 90%;
    margin: 0 auto;
    display: block;
    align-items: center:
    justify-content: center;
    img {
        height: 10%;
        width: 100%;
        display: block; 
        object-fit: cover;
        background-size: cover;
        margin: 0 auto;
    }
`

const Credits = styled.div`
    font-family: Optima regular font;
    color: #E5E5E5;
    text-align: right;
    font-style: italic;
    ${mediaQueries.mobile} {
        margin-left: 50%;
        font-size: 12px;
        padding-bottom: 0px;
  }
`


const Gif = (props) => {
    return (
        <>
            <Container>
                <img src = {props.file}></img>
                <Credits>
                    {`(${props.credit})`}
                </Credits>
            </Container>
           
        </>
    )

}




export default Gif;